/**
 * Root React tree — wraps QueryClient + Toast + Router providers around the Shell.
 *
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v2
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AdminAuthGate } from './auth-gate';
import { ToastHost, ToastProvider } from './components/toast';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10_000,
            refetchOnWindowFocus: true,
            retry: 1
        }
    }
});

export function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ToastProvider>
                <AdminAuthGate>
                    <RouterProvider router={router} />
                </AdminAuthGate>
                <ToastHost />
            </ToastProvider>
        </QueryClientProvider>
    );
}
